import React, { FC, useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import useStyles from './styles'
import { BaseLayout, Loader } from 'components'
import axios from 'axios'
import { api, routes } from 'config'
import ButtonWIthCustomCSS from 'components/custom-button/custom-button-style'

const PasswordAndSecurity: FC = () => {
  const { classes } = useStyles()

  const accessToken = JSON.parse(
    localStorage.getItem('okta-token-storage') ?? '',
  )?.accessToken?.accessToken

  const [isMFAEnrolled, setIsMFAEnrolled] = useState<boolean>(false)
  const [showLoader, setShowLoader] = useState<boolean>(false)

  useEffect(() => {
    setShowLoader(true)
    axios
      .get(api.getPhoneNumber(), {
        headers: {
          Authorization: accessToken,
        },
      })
      .then((res) => {
        const factor = res?.data
        setShowLoader(false)
        if (factor.factorType === 'sms') {
          setIsMFAEnrolled(true)
        }
      })
      .catch(() => {
        setShowLoader(false)
      })
  }, [accessToken])

  const actionSection = () => {
    const sectionItems = [
      {
        active: true,
        headLine: 'Account Password',
        summaryText:
          'Manage your account password you used to sign in that is unique to this account.',
        buttonCTA: 'Change Password',
        buttonAction: routes.changePassword,
      },
      {
        active: isMFAEnrolled,
        headLine: 'Two-Factor Authentication',
        summaryText:
          'For added security, we’ll send a verification code to ensure that only you can access the information you store in BrightMLS.',
        buttonCTA: 'Update Enrollment',
        buttonAction: routes.updateEnrollment,
      },
    ]
    return sectionItems.map((item) => (
      <>
        {item.active && (
          <Box key={item.headLine} className={classes.outlining}>
            <Box className={classes.textView}>
              <Typography className={classes.headLine}>
                {item.headLine}
              </Typography>
              <Typography className={classes.summaryText}>
                {item.summaryText}
              </Typography>
            </Box>
            <Box className={classes.buttonView}>
              <ButtonWIthCustomCSS
                color="primary"
                variant={'contained'}
                href={item.buttonAction}
                type="submit"
                style={{ boxShadow: 'unset', textTransform: 'none' }}
              >
                {item.buttonCTA}
              </ButtonWIthCustomCSS>
            </Box>
          </Box>
        )}
      </>
    ))
  }

  return (
    <>
      <Loader visible={showLoader} />
      {!showLoader && (
        <>
          <BaseLayout />
          <Box className={classes.moduleSpace}>
            <Box className={classes.outlineContainer}>
              <Typography className={classes.title}>
                Password & Security
              </Typography>
              {actionSection()}
            </Box>
          </Box>
        </>
      )}
    </>
  )
}

export default PasswordAndSecurity
